import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";
import Filter from "components/global/Filter/Filter";
import gridIcon from "assets/icons/grid-icon.svg";

import instance from "api/apiClient";
import { apiRoutes } from "configs/apiRoutes";

interface Props {
  onApply: (params: {
    search: string;
    active?: number;
    type?: string[];
  }) => void;
}

const FaqFilter: React.FC<Props> = ({ onApply }) => {
  const { t } = useTranslation();

  const [search, setSearch] = useState("");
  const [active, setActive] = useState<any[]>([]);
  const [type, setType] = useState<{ value: string | number; label: string }[]>(
    [],
  );
  const [types, setTypes] = useState<
    { value: string | number; label: string }[]
  >([]);

  useEffect(() => {
    const fetchTypes = async () => {
      try {
        const res = await instance.get(apiRoutes.seoTypes);
        const mapped = res.data.pages.map((el: string) => ({
          label: el,
          value: el,
        }));

        setTypes(mapped);
      } catch (e) {
        console.log(e);
      }
    };

    fetchTypes();
  }, []);

  const handleApply = () => {
    const payload = {
      search,
      active: active[0] && active[0].value !== 3 ? active[0].value : undefined,
      type: type.map((item) => String(item.value)),
    };
    onApply(payload);
  };

  const handleApplyType = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    setType(isDelete ? e : [...type, ...e]);
  };

  const handleClear = () => {
    setSearch("");
    setActive([{ value: 3, label: "All" }]);
    setType([]);

    onApply({
      search: "",
      active: undefined,
      type: [],
    });
  };

  return (
    <Filter
      handleClear={handleClear}
      handleApply={handleApply}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("title"),
          boxTitle: t("title"),
          icon: gridIcon,
          inputValue: search,
          setInputValue: setSearch,
          inputPlaceholder: t("title"),
          inputType: "text",
        },
        {
          type: FilterItemTypes.radio,
          title: t("isActive"),
          boxTitle: t("isActive"),
          icon: gridIcon,
          itemsArray: [
            { label: "Active", value: 1 },
            { label: "Inactive", value: 0 },
            { label: "All", value: 3 },
          ],
          activeItems: active,
          handleApply: setActive,
        },
        {
          type: FilterItemTypes.multiselect,
          title: "Type",
          boxTitle: t("filterTypes"),
          icon: gridIcon,
          itemsArray: types,
          activeItems: type,
          handleApply: handleApplyType,
        },
      ]}
    />
  );
};

export default FaqFilter;
